import { PartialType } from '../../../../utils';
import { CreateFeeWeekendPolicyDto } from '../create/create-fee-weekend-policy.dto';
export class UpdateFeeWeekendPolicyDto extends PartialType(CreateFeeWeekendPolicyDto) {
}
